const Init = () => {
    document.addEventListener("PelcroUserLoggedIn", (e) => {
        // console.log(e)

        if (!window.location.href.includes("login") || !window.location.href.includes("register")) {
            return;
        }

        /*const is_paywall_displayed = window.Pelcro.paywall.displayPaywall();

        // Paywall for subscribers
        if (is_paywall_displayed && e.details?.data?.subscriptions?.length > 0) {
            return;
        }*/

        setTimeout(() => {
            window.location.reload();
        }, 2000);
    })

    document.addEventListener("PelcroUserLoggedOut", (e) => {
        // Delete cookies

        // alert("assa")
        // window.location.reload();
    })

    document.addEventListener("PelcroUserRegister", (e) => {
        if (!window.location.href.includes("register")) {
            return;
        }

        setTimeout(() => {
            window.location.reload();
        }, 2000);
    })
}

export default {
    Init
}

/* window.Pelcro.paywall.displayPaywall() */